import { formatCurrency } from 'src/app/@utils/format-currency';

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatCurrency',
    standalone: true
})
export class FormatCurrencyPipe implements PipeTransform {
    transform(
        value: number,
        locale: string = 'da-DK',
        currencyCode: string = 'DKK',
        style: 'decimal' | 'currency' | 'percent' | 'unit' = 'currency'
    ): string {
        return formatCurrency(value, locale, currencyCode, style);
    }
}
